export const requiresApplyRoute = (command) => command.kind === "renderForm" || command.kind === "await";
export const buildApplyRoute = (amount) => {
    const query = new URLSearchParams();
    if (amount !== undefined) {
        query.set("amount", String(amount));
    }
    const displayed = query.toString();
    query.set("selected", "1");
    return {
        href: `/apply?${query}`,
        as: displayed ? `/apply?${displayed}` : "/apply",
    };
};
/**
 * Executes commands that navigate the visitor: `redirect` (external
 * URL) and `showMessage` (the rejection/error pages).
 * Returns false when the command required no navigation.
 */
export const handleNavigationCommandIfApplicable = async (command, router) => {
    const handleMessage = async (msg) => {
        if (msg.messageType !== "preset") {
            throw new Error("Custom messages are not yet supported");
        }
        switch (msg.preset) {
            case "PURCHASE_REJECTED":
                return router.push("/request-rejected");
            case "PURCHASE_ERROR":
                return router.push("/request-failed");
            default:
                throw new Error("Message preset is not yet supported: " + msg.preset);
        }
    };
    switch (command.kind) {
        case "redirect":
            window.location.href = command.url;
            return true;
        case "showMessage":
            return handleMessage(command.message);
        default:
            return false;
    }
};
export const handlePollingCommand = (command, controller, router) => {
    if (command.kind !== "await") {
        return Promise.resolve(command);
    }
    return new Promise((resolve) => {
        setTimeout(() => {
            controller
                .poll(command.requestId)
                .then(async (result) => {
                await handleNavigationCommandIfApplicable(result.command, router);
                resolve(result.command);
            })
                .catch(async () => {
                // All poll retries exhausted — navigate to the error page
                const errorCommand = {
                    kind: "showMessage",
                    message: { messageType: "preset", preset: "PURCHASE_ERROR" },
                };
                await handleNavigationCommandIfApplicable(errorCommand, router);
                resolve(errorCommand);
            });
        }, command.pollAfterMs);
    });
};
